import React from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";

import {Box} from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';

import {Spacer} from "../../qdep/components/util/spacer/Spacer";
import {Workspace} from "../../qdep/components/workspace/Workspace";
import {LoginWorkspaceBlock} from "../../workspace/auth/login-block/LoginWorkspaceBlock";
import {AppState} from "../state/state";

import './LoginPage.css'


interface LoginPageProps {
    isLogged: boolean
    isWaiting: boolean
    errorMessage?: string

    appVersion: string
}

const LoginPage = (props: LoginPageProps) => {
    if (props.isLogged) {
        return <Redirect to="/"/>
    }

    return <Workspace className="login-page-workspace">
        <LoginWorkspaceBlock isWaiting={props.isWaiting}/>
        { props.errorMessage !== undefined && <Box className={"login-page-error-container"}>
            <WarningIcon color={"error"}/>
            <span className={"text"}>{ props.errorMessage }</span>
        </Box> }
        <Spacer/>
        <div className={"platform-desc"}>
            <div>ФАКТ / PTO Checker App { props.appVersion }</div>
            <div>powered by QDep App Platform v1.1.7</div>
        </div>
    </Workspace>;
}

const mapStateToProps = (state: AppState): Omit<LoginPageProps, "appVersion"> => {
    return {
        isLogged: state.auth.isLogged,
        isWaiting: state.auth.isWaiting,
        errorMessage: state.auth.errorMessage,
    };
}

const ConnectedLoginPage = connect(mapStateToProps)(LoginPage)

export {ConnectedLoginPage as LoginPage}